module.exports = __webpack_public_path__ + "img/r5.a3ddc240.jpg";